import React, { FC, ChangeEvent, useState } from 'react'
import cn from 'classnames'

import moduleStyles from './ResultsPerPage.module.scss'

const DEFAULT_SELECTED_OPTION = 10
const DEFAULT_OPTIONS_LIST = [10, 100]

type OptionsListProps = {
  values: number[]
  selectedValue: number
  onSelectChange?: (value: number) => void
  classes: string
}

const OptionsList: FC<OptionsListProps> = (props) => {
  // Props
  const { values, selectedValue, onSelectChange, classes } = props

  //State
  const [newSelectedOption, setNewSelectedOption] = useState<number>(selectedValue)

  // Methods
  const handleValueChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const value = parseInt(e.currentTarget.value)
    setNewSelectedOption(value)

    // Exec method only if exists
    onSelectChange?.(value)
  }

  return (
    <select
      className={classes}
      value={newSelectedOption}
      onChange={(e) => handleValueChange(e)}
      data-test-id="results_per_page_select"
    >
      {values.map((value) => {
        return (
          <option value={value} key={value} data-test-id="results_per_page_select_option">
            {value}
          </option>
        )
      })}
    </select>
  )
}

type ResultsPerPageProps = {
  options?: number[]
  selectedOption?: number
  onChange?: (option: number) => void
  customStyles?: any
}

const ResultsPerPage: React.FC<ResultsPerPageProps> = (props) => {
  // Props
  const {
    options = DEFAULT_OPTIONS_LIST,
    selectedOption = DEFAULT_SELECTED_OPTION,
    onChange,
    customStyles = {},
  } = props

  // Styles
  const containerStyles = cn(moduleStyles.container, { [customStyles.container]: !!customStyles.container })
  const labelStyles = cn(moduleStyles.label, { [customStyles.label]: !!customStyles.label })
  const optionsListStyles = cn(moduleStyles.select, { [customStyles.select]: !!customStyles.select })

  // Values
  const optionsListValues = options.includes(selectedOption) ? options : DEFAULT_OPTIONS_LIST
  const optionsListSelectedValue = options.includes(selectedOption) ? selectedOption : DEFAULT_SELECTED_OPTION

  return (
    <div className={containerStyles}>
      <label className={labelStyles} data-test-id="results_per_page_label">
        Results per page:
      </label>
      <OptionsList
        values={optionsListValues}
        selectedValue={optionsListSelectedValue}
        onSelectChange={onChange}
        classes={optionsListStyles}
      />
    </div>
  )
}

export default ResultsPerPage
